import { defineComponent as _defineComponent } from 'vue'
import Breadcrumbs from "@/components/ui/Breadcrumbs";
  import SwitchComponent from "@/components/ui/SwitchComponent.vue";
  import LotApproveButton from "@/components/Lot/LotApproveButton.vue";
  import DocumentItem from "@/components/ui/DocumentItem.vue";
  import AddToWeitlistModal from "@/components/ui/modals/AddToWeitlistModal.vue";
  import RemoveFromWeitlistModal from "@/components/ui/modals/RemoveWaitlistModal.vue";
  import Notes from "@/components/contacts/Notes.vue";
  import Payments from "@/components/contacts/Payments.vue";
  import DeletedUserBlock from "@/components/ui/DeletedUserBlock.vue";
  import router from "@/router";
  import store from "@/store";
  import { Breadcrumb } from "@/types";
  import { computed, onMounted, onUnmounted, ref, watch } from "vue";
  import { useRoute } from "vue-router";
  import { getContactStatusClass } from "@/helpers/status";
  import { contactStatus } from "@/helpers/contactStatus";
  import { EoiStatus } from "@/enums/EoiStatus";
  import { SubscriptionInterface } from "@/types/SubscriptionInterface";
  import { EoiInterface } from "@/types/EoiInterface";
  import { StageInterface } from "@/types/StageInterface";
  import { formatPrice } from "@/helpers/transformation/price";
  import { StageStatus } from "@/enums/StageStatus";
  import { getLotStatusClass } from "@/helpers/status";
  import { LotInterface } from "@/types/LotInterface";
  import { DocumentTypeEnum } from "@/enums/DocumentTypeEnum";
  import LotDocuments from "@/views/lot/LotDocuments.vue";
  import { useToast } from "vue-toastification";
  import { getLandownerEoiStatus } from "@/helpers/eoi";
  import { lotRequestInterval } from "@/static/lot";
  import { LotStatus } from "@/enums/LotStatus";
  import { isCollaborator } from "@/helpers/estate/isCollaborator";
  import { EstateInterface } from "@/types/EstateInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ContactsDetailsView',
  setup(__props, { expose: __expose }) {
  __expose();

  const route = useRoute();
  const toast = useToast();

  const tabs = [
    { label: "PAYMENTS" },
    { label: "NOTES" },
    { label: "REQUESTS" },
    { label: "CONTRACTS" },
  ];

  const currentTab = ref(tabs[0]);

  const customerId = computed(() => {
    return route.params.id;
  });
  const estateId = computed(() => {
    return store.state.user.selectedEstateId;
  });

  onMounted(() => {
    init();
  });
  onUnmounted(() => {
    clearInterval(timerId);
  });

  function init() {
    getUser();
    getEstate();
  }

  function getUserInfo() {
    getSubscription();
    getEoi();
    getStages();
    getAssignedLots();
  }

  const lotPrferences = ref<SubscriptionInterface>({} as SubscriptionInterface); // subscriptions
  const requests = ref<EoiInterface[]>([]); // eoi
  const userInfo = ref<any>(); //TODO: add type after backend changings
  const estate = ref<EstateInterface | null>(null);
  const isApprovLoading = ref(false);
  const isApproving = computed(() => {
    if (isApprovLoading.value) {
      return true;
    }

    for (const eoi of requests.value) {
      if (eoi.status === EoiStatus.WAITING_FOR_APPROVED) {
        return true;
      }
    }

    return false;
  });
  let timerId: number | undefined;
  const getEstate = () => {
    store.dispatch("estate/getEstate", estateId.value).then((res) => {
      estate.value = res.data;
    });
  };

  watch(
    () => isApproving.value,
    (value, prevValue) => {
      if (value && value !== prevValue) {
        timerId = setInterval(getEoi, lotRequestInterval);
      } else {
        clearInterval(timerId);
      }
    }
  );

  const userStatus = ref("");
  const params = computed(() => {
    return {
      customerId: customerId.value,
      estateId: estateId.value,
    };
  });

  const inWaitList = ref(false);
  const subscriptionId = ref("");

  function getSubscription() {
    store.dispatch("subscription/getSubscription", params.value).then((res) => {
      lotPrferences.value = res.data[0];
      inWaitList.value = !!lotPrferences.value?._id;
    });
  }
  const getEoi = () => {
    store
      .dispatch("eoi/getEois", {
        ...params.value,
        status: [
          EoiStatus.PENDING,
          EoiStatus.APPROVED,
          EoiStatus.DECLINED,
          EoiStatus.WAITING_FOR_APPROVED,
          EoiStatus.WAITING_FOR_DECLINED,
          EoiStatus.WITHDRAWN,
          EoiStatus.REFUNDED,
          EoiStatus.REFUND_DECLINED,
          EoiStatus.TRANSACTION_ERROR,
        ],
      })
      .then((res) => {
        requests.value = res.data;
        isApprovLoading.value = false;
        documents.value = [];
        requests.value.forEach((item) => {
          if (item.buyersData?.firstBuyer?.documents?.length > 0) {
            documents.value.push(...item.buyersData.firstBuyer.documents);
          }

          if (item.buyersData?.secondBuyer?.documents?.length > 0) {
            documents.value.push(...item.buyersData.secondBuyer.documents);
          }

          if (
            item.contractConditions?.bankApprovalDocument &&
            item.contractConditions?.bankApprovalDocument.link
          ) {
            documents.value.push(item.contractConditions.bankApprovalDocument);
          }

          if (item.contractDocuments.length) {
            item.contractDocuments.forEach((doc) => {
              contracts.value.push(doc);
            });
          }
        });
      });
  };
  const fullName = ref("");
  const initials = ref("");
  const contracts = ref<Document[]>([]);
  const usersLotsArray = ref<LotInterface[]>([]);

  const deletedUser = ref(false);
  const loading = ref(false);

  function getUser() {
    loading.value = true;
    store
      .dispatch("user/getUser", customerId.value)
      .then((res) => {
        if (!res.data) {
          deletedUser.value = true;
          return;
        }

        getUserInfo();
        userInfo.value = res.data;
        userStatus.value = contactStatus(
          userInfo.value?.detailsId.contactStatuses,
          estateId.value
        );
        fullName.value = `${userInfo.value?.firstName} ${userInfo?.value?.middleName} ${userInfo.value?.lastName}`;
        initials.value = `${userInfo.value?.firstName[0] || ""}${
          userInfo.value?.lastName[0] || ""
        }`;
      })
      .finally(() => {
        loading.value = false;
      });
  }

  function getAssignedLots() {
    store
      .dispatch("eoi/getCustomerLotList", {
        id: customerId.value,
        data: { estateId: estateId.value, status: EoiStatus.APPROVED },
      })
      .then((res) => {
        usersLotsArray.value = res.data;
      });
  }
  // - eoi lot confirmation
  function onConfirmLot() {
    getEoi();
  }

  function lotInfo(item: any) {
    return {
      lot: item?.lotId?.title,
      name:
        item?.buyersData?.firstBuyer?.firstName +
        " " +
        item?.buyersData?.firstBuyer?.lastName,
      eoiId: item?._id,
      lotId: item?.lotId?._id,
    };
  }

  //- files
  const documents = ref([]);

  //- crumbs
  const crumbs = computed(() => {
    return [
      { label: "Contacts", path: "/contacts" },
      {
        label: `${userInfo.value?.detailsId ? fullName.value : ""}`,
      },
    ];
  });

  // waitlist modal
  const isOpenWaitlistModal = ref(false);

  function openWaitlistModal() {
    isOpenWaitlistModal.value = true;
  }
  function closeWaitlistModal() {
    isOpenWaitlistModal.value = false;
  }
  function onConfirmWaitlistModal() {
    closeWaitlistModal();
    getSubscription();
  }

  const isOpenRemoveModal = ref(false);

  function openRemoveModal() {
    isOpenRemoveModal.value = true;
  }
  function closeRemoveModal() {
    isOpenRemoveModal.value = false;
  }
  function onConfirmRemoveModal() {
    closeRemoveModal();
    getSubscription();
  }

  const stagesList = ref([]);

  function getStages() {
    store
      .dispatch("stage/getStages", {
        estateId: estateId.value,
      })
      .then((res) => {
        stagesList.value = res.data.map((item: StageInterface) => {
          return {
            title: item.title,
            id: item._id,
            disabled: item.status === StageStatus.SOLD_OUT,
          };
        });
        getLots();
      });
  }

  const lotsArray = ref([]);

  function getLots() {
    const stages = stagesList.value
      .filter((item) => !item.disabled)
      .map((item) => item.id);

    store
      .dispatch("lot/getStagesLots", {
        stageIds: stages,
      })
      .then((res) => {
        lotsArray.value = res.data;
      });
  }

  function onRow(item: EoiInterface) {
    if (
      !isApproving.value ||
      item.status === EoiStatus.WAITING_FOR_APPROVED ||
      item.status === EoiStatus.WAITING_FOR_DECLINED
    ) {
      router.push(`/eoi/${item._id}`);
    }
  }

  function getName(first: string, last: string): string {
    return [first, last].filter((n) => n).join(" ");
  }

  const disableInvite = ref(false);

  function inviteToWaitlist() {
    disableInvite.value = true;
    store
      .dispatch("subscription/inviteToWaitlist", {
        id: estateId.value,
        params: {
          customerFirstName: userInfo.value?.firstName || "",
          customerEmail: userInfo.value?.email.toLowerCase(),
        },
      })
      .then(() => {
        toast.success("Email was sent successfully");
      })
      .catch(() => {
        toast.error("Something went wrong");
      })
      .finally(() => {
        disableInvite.value = false;
      });
  }

  function getDisplayStatusClass(status: LotStatus) {
    return getLotStatusClass(
      status === LotStatus.EOI ? LotStatus.PRE_CONTRACT : status
    );
  }

const __returned__ = { route, toast, tabs, currentTab, customerId, estateId, init, getUserInfo, lotPrferences, requests, userInfo, estate, isApprovLoading, isApproving, get timerId() { return timerId }, set timerId(v) { timerId = v }, getEstate, userStatus, params, inWaitList, subscriptionId, getSubscription, getEoi, fullName, initials, contracts, usersLotsArray, deletedUser, loading, getUser, getAssignedLots, onConfirmLot, lotInfo, documents, crumbs, isOpenWaitlistModal, openWaitlistModal, closeWaitlistModal, onConfirmWaitlistModal, isOpenRemoveModal, openRemoveModal, closeRemoveModal, onConfirmRemoveModal, stagesList, getStages, lotsArray, getLots, onRow, getName, disableInvite, inviteToWaitlist, getDisplayStatusClass, get Breadcrumbs() { return Breadcrumbs }, SwitchComponent, LotApproveButton, DocumentItem, AddToWeitlistModal, RemoveFromWeitlistModal, Notes, Payments, DeletedUserBlock, get router() { return router }, get store() { return store }, get Breadcrumb() { return Breadcrumb }, computed, onMounted, onUnmounted, ref, watch, get useRoute() { return useRoute }, get getContactStatusClass() { return getContactStatusClass }, get contactStatus() { return contactStatus }, get EoiStatus() { return EoiStatus }, get SubscriptionInterface() { return SubscriptionInterface }, get EoiInterface() { return EoiInterface }, get StageInterface() { return StageInterface }, get formatPrice() { return formatPrice }, get StageStatus() { return StageStatus }, get getLotStatusClass() { return getLotStatusClass }, get LotInterface() { return LotInterface }, get DocumentTypeEnum() { return DocumentTypeEnum }, LotDocuments, get useToast() { return useToast }, get getLandownerEoiStatus() { return getLandownerEoiStatus }, get lotRequestInterval() { return lotRequestInterval }, get LotStatus() { return LotStatus }, get isCollaborator() { return isCollaborator }, get EstateInterface() { return EstateInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})